import { IconProps } from "./types";

export default function IcoResident({ color = "#1D1D1D", size = "16" }: IconProps) {
	return (
		<svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7 8.33556H10V14M4 14H12C13.1046 14 14 13.0778 14 11.9402V6.59493C14 5.87964 13.6397 5.21557 13.0482 4.84069L9.0482 2.30555C8.40538 1.89815 7.59462 1.89815 6.95181 2.30555L2.95181 4.84069C2.36031 5.21557 2 5.87964 2 6.59493V11.9402C2 13.0778 2.89543 14 4 14Z"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
